module.exports = __webpack_public_path__ + "static/media/plan-oferta-wom-mas-gblibres.282dc624.svg";